import React from 'react';
import { Card } from 'antd';
import ImportContactsIcon from 'mdi-react/ImportContactsIcon';

import './RevistaCoopercitrus.scss';

const RevistaCoopercitrus = (): JSX.Element => {
  return (
    <Card
      style={{ width: 150, height: 150 }}
      hoverable
      onClick={
        (): void => {
          window.open('https://coopercitrus.com.br/noticias/revistas/', '_blank');
        }
      }
      className="RevistaCoopercitrus"
    >
      <ImportContactsIcon size={60} className="RevistaCoopercitrus__icon" />
      <Card.Meta title="Revista Coopercitrus" className="RevistaCoopercitrus__title" />
    </Card>
  );
};

RevistaCoopercitrus.propTypes = {};
RevistaCoopercitrus.defaultProps = {};

export default RevistaCoopercitrus;
